import { filterProduct } from 'embed/filterProducts'
import backendData from 'backend-data/index.js.erb'
import axios from 'axios';
import {
  isProductPage, isWoocommercePlatform,
  isBigcommercePlatform, serializeArray,mfToken
} from 'embed/helpers'

const getProductFromProductPage = (data, userSettings) => {
  const product = data.product
  const variantObj = getSelectedVariant(product)
  if (!variantObj || variantObj.available == false) return []
  let minPurhase = product.min_purchase_quantity
  const productObj = {
    title: product.title,
    variant_title: variantObj.title && variantObj.title !== "Default Title" ? variantObj.title : '',
    img: getImageUrl(product, variantObj),
    url: location.href,
    variant: variantObj.id,
    available: variantObj.available,
    price: getPrice(product, variantObj),
    sku: variantObj.sku,
    tags: product.tags,
    collections: getCollections(product),
    product_id: product.id,
    options: JSON.stringify(variantObj.options),
    min_purchase_quantity: minPurhase == undefined|| minPurhase == '0' ? 1 : minPurhase
  }
  if (filterProduct(userSettings, productObj)) return [productObj]
  return []
}

const getCartItemsFromCartItemsPage = (data, userSettings) => {
  let items = []
  data.cartProducts.forEach((p) => {
    if (p.available != false && filterProduct(userSettings, p)) {
      let collections = p.collections && p.collections.map(c => c.title ? c.title.toLowerCase() : c.name.toLowerCase()) || []
      items.push({
        title: p.title,
        price: p.price.replace(/ /g, ''),
        img: p.image,
        url: location.protocol + '//' + location.hostname + p.url,
        available: p.available,
        sku: p.sku,
        tags: p.tags,
        collections: collections,
        variant: p.variant_id || getVariantOfCartProduct(p),
        product_id: p.id
      });
    }
  })
  return items
}

const getProductFromProductVariantPage = (data, userSettings) => {
  let variantQuantity = userSettings.check_variant_quantity
  if(variantQuantity){
    const product = data.product
    const variantObj = getSelectedVariant(product)
    let requestData = {id: variantObj.id};
    let updateUrl = `${backendData.protocol}://${backendData.hostUrl}/offers/variant_stock?mf_tkn=${mfToken()}`;
    axios.post(updateUrl, requestData)
    .then((response) => {
      let variantInStock = response && response.data.instock
      const parent_div = document.querySelector('#mf_container');
      let element = parent_div && parent_div.querySelector('.mf_button');
      if(element) {
        if(variantInStock) {
          element.style.removeProperty('display');
        }else {
          element.style.display = 'none'
        }
      }
    })
  }
}

const getSelectedVariant = (product) => {
  const productFormClass = 'mf_product_form'
  if (isWoocommercePlatform()) {
    const form = document.getElementsByClassName(productFormClass)[0]
    let variantInput = form.querySelector('[name="variation_id"]')
    if (variantInput) {
      let variantId = Number(variantInput.value)
      let variant = product.variants.find((v) => v.variation_id == variantId)
      if (variant) return variant
    }
    let variant = product.variants[0]
    if (variant == undefined) {
      return {}
    }
    return variant
  } else if (isBigcommercePlatform()) {
    let variantO = Object.assign({}, product);
    let options = {};
    product.options.forEach((option) => {
      if (option.values && option.values.length) {
        let selected = option.values.filter(v => v.selected)
        options[option.id] = selected.length ? selected[0].id : option.values[0].id;
      } else if (options.value) {
        options[option.id] = option.value
      }
    })
    const form = document.getElementsByClassName(productFormClass)[0];
    let data = serializeArray(form);
    data.forEach((item) => {
      if (item.name.match('attribute') && item.value != '') {
        options[item.name.match(/\d+/g)[0]] = item.value
      }
    })

    variantO.options = options;
    return variantO;
  } else {
    let variantId = getVariantFromForm() || getVariantFromUrl()
    return product.variants.find((v) => v.id == variantId)
  }
}

const getVariantFromForm = () => {
  const form = document.getElementsByClassName('mf_product_form')[0]
  if (form) {
    let variantEl = form.querySelector('[name="id"]')
    // To Get Variant DIV Element for Shopify Xtra Theme
    variantEl = variantEl ? variantEl : form.querySelector('[data-type="variantId"]')
    if (variantEl) {
      return (variantEl.value || (variantEl.dataset && variantEl.dataset.value))
    } else {
      console.log('form is not find (make and offer)')
      return false
    }
  } else {
    console.log('form is not find (make and offer)')
    return false
  }
}

const getVariantFromUrl = () => {
  let variant_id = null;
  let regex = /variant=(\d+)/g.exec(location.href);
  if (regex) variant_id = parseInt(regex[1]);
  return variant_id
}

const getVariantOfCartProduct = (cartProduct) => {
  let variant_id = parseInt(/variant=(.*)/g.exec(cartProduct.url)[1]);

  if (variant_id === undefined) {
    console.log("Cannot find variant of cartProduct:", cartProduct);
    return null;
  }
  return variant_id;
}

const priceWithCurrency = (currency, price) => {
  if (!currency) {
    return price
  }
  var replacedValue = currency.match(/{{[a-z_\s]+}}/i)[0]
  return currency.replace(replacedValue, price)
}

const getPrice = (product, variantObj) => {
  if (isWoocommercePlatform()) {
    var price = variantObj.display_price || product.price;
    return product.currency.replace(/[\d.,]+/, price)
  } else if (isBigcommercePlatform()) {
    return product.currency
  } else {
    return priceWithCurrency(product.currency, (variantObj.price / 100).toFixed(2))
  }
}

const getImageUrl = (product, variantObj) => {
  if (isWoocommercePlatform()) {
    return variantObj.image ? variantObj.image.url : product.image
  } else if (isBigcommercePlatform()) {
    return product.image
  } else {
    return variantObj.featured_image ? variantObj.featured_image.src : product.image
  }
}

const getCollections = (product) => {
  if (isWoocommercePlatform()) {
    return product.collections.map(c => c.name.toLowerCase())
  } else if (isBigcommercePlatform()) {
    return product.collections.map(c => c.toLowerCase())
  } else {
    return product.collections.map(c => c.title.toLowerCase())
  }
}

export const initializeProducts = (data, userSettings) => {
  if (isProductPage(userSettings) && data.product) {
    return getProductFromProductPage(data, userSettings)
  } else {
    return getCartItemsFromCartItemsPage(data, userSettings)
  }
}

export const initializeProductsVariant = (data, userSettings) => {
  if (isProductPage(userSettings) && data.product) {
    return getProductFromProductVariantPage(data, userSettings)
  }
}